module.exports = __webpack_public_path__ + "static/img/playStop.e7871fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/playStop.png
// module id = 0+zr
// module chunks = 1